import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Col, Row, Card, CardHeader, CardBody, FormGroup, Form, FormFeedback, Table, Modal, ModalBody, ModalHeader, InputGroup } from "reactstrap";
import { useEffect, useState } from "react";
import moment from "moment";
import { LabelText } from "../Utils/Input";
import { handleSelectOffer } from "./constants/OrderFilterFunctions";
import CommonDateTimePicker from "../Utils/CommonDateTimePicker";
import InputField from "../Utils/InputField";
import SelectField from "../Utils/SelectField";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { subscribeOrder } from "../../slices/orderManagement/Subscribe/thunk";
import { Link } from "react-router-dom";
import LimitOverride from "../Customers/LimitOverride";
import OfferCard from "./OfferCard";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from 'reactstrap';

let numberofItems = 3
export const OrderFilterAccordion = ({ open, toggle, loading, filteredResults, navigate, setLoading, subscriptionId }) => {
  const [selectedOffers, setSelectedOffers] = useState([]);
  const [startsOn, setStartsOn] = useState(null);
  const [endsOn, setEndsOn] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const roleName = localStorage.getItem("roleName");
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(null);
  const [attributes, setAttributes] = useState(false);
  const [viewDetails, setViewDetails] = useState({});
  const [resourceOptions, setResourceOptions] = useState([]);
  const [overrideResource, setOverrideResource] = useState({
    0: [{ resourceName: null, value: "" }],
  });
  const [formValues, setFormValues] = useState({
    subscriptionId: "",
    startsOn: null,
  });

  const [isViewMoreModalOpen, setIsViewMoreModalOpen] = useState(false);
  const [openViewMoreModalKey, setOpenViewMoreModalKey] = useState(null);
  const [openSubscriptionModalKey, setOpenSubscriptionModalKey] =
    useState(null);
  const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  const openViewMoreModal = (index, offerIndex) => {
    setOpenViewMoreModalKey(`${index}-${offerIndex}`);
  };
  const closeViewMoreModal = () => {
    setOpenViewMoreModalKey(null);
  };
  const openSubscriptionModal = (index, offerIndex) => {
    setOpenSubscriptionModalKey(`${index}-${offerIndex}`);
  };

  const closeSubscriptionModal = () => {
    setOpenSubscriptionModalKey(null);
  };
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );
  const prefix = operatorConfiguration?.configurations?.Prefixes?.value?.OrderPrefix?.value
  const sequence = operatorConfiguration?.configurations?.SequenceHandling?.value?.OrderSequence?.value
  const id = prefix && prefix + "X".repeat(sequence?.length);

  const addOn = location.pathname.includes('add-on')
  const dispatch = useDispatch()
  const handleSelect = (offer, offerIndex, index) => {
    if (roleName === 'telcoAdmin' || roleName === 'telcoOperationUser' || roleName === 'telcoBusinessUser') {
      setSelectedOffers([offer]);
      setSelectedItemIndex(offerIndex)
      setSelectedServiceIndex(index)
      setAttributes(offer?.provisioningAttributes?.length > 0)
      const grants = offer?.Grants?.filter(grant => grant.overridable === true)?.map(grant => grant.resourceName);
      const charges = offer?.Charges?.filter(charge => charge.overridable === true)?.map(charge => charge.resourceName);
      setResourceOptions([...grants, ...charges]);
      setOverrideResource(prev => ({
        ...prev,
        [offerIndex]: prev[offerIndex] || [{ resourceName: null, value: '' }]
      }));
    } else {
      handleSelectOffer(offer, navigate, subscriptionId);
    }
  };
  const handleAddResource = (offerIndex) => {
    setOverrideResource(prev => ({
      ...prev,
      [offerIndex]: [
        ...(prev[offerIndex] || []),
        { resourceName: null, value: '' }
      ]
    }));
  };
  const handleRemoveResource = (offerIndex, resourceIndex) => {
    setOverrideResource(prev => {
      const updatedResources = [...(prev[offerIndex] || [])];
      updatedResources.splice(resourceIndex, 1);

      return {
        ...prev,
        [offerIndex]: updatedResources,
      };
    });
  };
  const toggleViewDetails = (serviceIndex, offerIndex) => {
    const key = `${serviceIndex}-${offerIndex}`;
    setViewDetails((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const filteredResources = Object.values(overrideResource)
    .flat()
    .filter(resource => resource.resourceName?.value?.trim())
    .map(resource => ({
      resourceName: resource.resourceName.value,
      amount: parseFloat(resource.value) || 0
    }));
  const initialValues = {
    subscriptionId: "",
    startsOn: null
  }
  const handleConfirm = (values) => {
    const selectedData = selectedOffers.map((offer) => ({
      offer,
      startsOn,
      endsOn,
      subscriptionID: values.subscriptionId
    }));

    moment(values.offerStartsOn).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
    if (selectedData.length > 0) {
      const jsonData = {
        subscriptionId: values.subscriptionId || (addOn ? subscriptionId : selectedData[0]?.subscriptionID), offerCode: selectedData[0]?.offer.offerCode,
        customerId: selectedData[0]?.offer.CustomerId,
        quantity: quantity,
        validFrom: values.startsOn ? moment(values.startsOn?._d).format('YYYY-MM-DDTHH:mm:ss[Z]') : moment().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        // ...(values.startsOn && {validFrom: moment(values.startsOn?._d).format('YYYY-MM-DDTHH:mm:ss[Z]'),}),
        ...(endsOn && { validTo: moment(endsOn?._d).format('YYYY-MM-DDTHH:mm:ss[Z]'), }),
        ...(values.floor && { floor: parseFloat(values.floor) }),
        ...(values.ceiling && { ceiling: parseFloat(values.ceiling) }),
        ...(filteredResources.length > 0 ? { resources: filteredResources } : {})
      };
      if (jsonData.subscriptionId !== "" && jsonData.validFrom) {
        dispatch(subscribeOrder(jsonData, setLoading, navigate));
      }
    }
  };

  const validationSchema = Yup.object({
    subscriptionId: id ? Yup.string() : Yup.string().required('Kindly enter Subscription ID'),
  })


  const [activeIndices, setActiveIndices] = useState({});


  const next = (key, chunkCount) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: ((prev[key] ?? 0) + 1) % chunkCount,
    }));
  };

  const previous = (key, chunkCount) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: ((prev[key] ?? 0) - 1 + chunkCount) % chunkCount,
    }));
  };

  const goToIndex = (key, index) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: index,
    }));
  };



  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMediumToLargeScreen, setIsMediumToLargeScreen] = useState(window.innerWidth >= 768 && window.innerWidth < 1400);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsMediumToLargeScreen(window.innerWidth >= 768 && window.innerWidth < 1400)
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const offerSlides = (offers, serviceIndex) => {
    const numberOfItems = isMobile ? 1 : isMediumToLargeScreen ? 3 : 4;
    const offerChunks = [];
    for (let i = 0; i < offers.length; i += numberOfItems) {
      offerChunks.push(offers.slice(i, i + numberOfItems));
    }

    const slides = offerChunks.map((offerChunk, index) => (
      <CarouselItem
        key={`chunk-${index}`}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <div className="d-flex justify-content-center w-100">
          <Row className="px-2 w-95">
            {offerChunk.map((offer, offerIndex) => {
              const adjustedOfferIndex = index * numberOfItems + offerIndex
              return <Col
                key={adjustedOfferIndex}
                lg={4}
                xxl={3}
                sm={12}
                className="mb-4"
              >
                <OfferCard
                  offer={offer}
                  index={serviceIndex}
                  offerIndex={adjustedOfferIndex}
                  openViewMoreModal={openViewMoreModal}
                  openSubscriptionModal={openSubscriptionModal}
                  closeSubscriptionModal={closeSubscriptionModal}
                  handleSelect={handleSelect}
                />
                <Modal
                  isOpen={
                    openSubscriptionModalKey === `${serviceIndex}-${adjustedOfferIndex}`
                  }
                  fade={false}
                  toggle={closeSubscriptionModal}

                  className="custom-modal-width-850 offerModal"
                  centered={true}
                >
                  <ModalHeader
                    className="d-flex justify-content-center rv-breadcrumb-border p-3"
                  >
                    <div className="w-100 text-center">Subscription</div>
                    <button type="button" className="close-button-currency mt-n1 fs-1 align-self-center" onClick={closeSubscriptionModal}>
                      &times;
                    </button>
                  </ModalHeader>
                  <ModalBody>
                    {(roleName === "telcoAdmin" ||
                      roleName === "telcoOperationUser" ||
                      roleName === "telcoBusinessUser") &&
                      selectedItemIndex === adjustedOfferIndex &&
                      selectedServiceIndex === serviceIndex &&
                      selectedOffers.map((offer, index) => (
                        <Formik
                          initialValues={initialValues}
                          validationSchema={validationSchema}
                          enableReinitialize
                          onSubmit={handleConfirm}
                          validateOnChange={false}
                          validateOnBlur={false}
                        >
                          {({
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                            handleBlur,
                            setFieldValue,
                          }) => {
                            useEffect(() => {
                              setFormValues(values);
                            }, [values]);
                            return (
                              <Form
                                onSubmit={
                                  addOn ? handleConfirm : handleSubmit
                                }
                              >
                                <div>
                                  <Row className="gy-3 mt-1">
                                    <Col lg={3} md={12}>
                                      <div>
                                        <FormGroup>
                                          <LabelText
                                            htmlFor={"subscriptionId"}
                                            classLabelName={
                                              "ms-0 rv-form-label"
                                            }
                                            className={"text-danger"}
                                            displayText={
                                              "Subscription Id"
                                            }
                                            important={!id && "*"}
                                          />
                                          <LabelText
                                            htmlFor={"subscriptionId"}
                                            classLabelName={`d-block ms-0 rv-sub-label ${touched.subscriptionId &&
                                              errors.subscriptionId
                                              ? "rv-label-danger"
                                              : "rv-label-muted"
                                              } `}
                                            displayText={
                                              touched.subscriptionId &&
                                                errors.subscriptionId
                                                ? errors.subscriptionId
                                                : `Enter Subscription ID`
                                            }
                                          />
                                          <InputField
                                            name={"subscriptionId"}
                                            type={"text"}
                                            className={"form-control"}
                                            id={"code"}
                                            value={
                                              addOn
                                                ? subscriptionId
                                                : values.subscriptionId
                                            }
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            disabled={addOn}
                                            invalid={
                                              touched.subscriptionId &&
                                                errors.subscriptionId &&
                                                !addOn
                                                ? true
                                                : false
                                            }
                                          />
                                        </FormGroup>
                                      </div>
                                    </Col>
                                    <Col lg={3} md={12}>
                                      <div>
                                        <FormGroup>
                                          <LabelText
                                            htmlFor={"startsOn"}
                                            classLabelName={
                                              "ms-0 rv-form-label"
                                            }
                                            className={"text-danger"}
                                            displayText={
                                              "Subscription Starts On"
                                            }
                                          />
                                          <LabelText
                                            htmlFor={"startsOn"}
                                            classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                                            displayText={dateFormat}
                                          />
                                          <CommonDateTimePicker
                                            placeholder=""
                                            className={`form-control`}
                                            value={values.startsOn}
                                            name={`startsOn`}
                                            handleChange={(val) => {
                                              setFieldValue(
                                                "startsOn",
                                                val
                                              );
                                            }}
                                            format={dateFormat}
                                            views={[
                                              "year",
                                              "month",
                                              "day",
                                            ]}
                                          />
                                        </FormGroup>
                                      </div>
                                    </Col>
                                    <Col lg={3} md={12}>
                                      <div>
                                        <FormGroup>
                                          <LabelText
                                            htmlFor={"endsOn"}
                                            classLabelName={
                                              "ms-0 rv-form-label"
                                            }
                                            className={"text-danger"}
                                            displayText={
                                              "Subscription Ends On"
                                            }
                                          />
                                          <LabelText
                                            htmlFor={"endsOn"}
                                            classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                                            displayText={dateFormat}
                                          />
                                          <CommonDateTimePicker
                                            className={`form-control`}
                                            value={endsOn}
                                            name={`endsOn`}
                                            handleChange={(val) => setEndsOn(val)}
                                            minDate={values.startsOn}
                                            format={dateFormat}
                                            views={[
                                              "year",
                                              "month",
                                              "day",
                                            ]}
                                          />
                                        </FormGroup>
                                      </div>
                                    </Col>
                                    <Col lg={3} md={12}>
                                      <FormGroup>
                                        <LabelText
                                          htmlFor={"Quantity"}
                                          classLabelName={
                                            "ms-0 rv-form-label"
                                          }
                                          className={"text-danger"}
                                          displayText={"Quantity"}
                                        />
                                        <LabelText
                                          htmlFor={"Quantity"}
                                          classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                                          displayText={"Select Quantity"}
                                        />
                                        <InputGroup className="border border-1 rounded-1 d-flex justify-content-between align-items-center">
                                          <input
                                            type="number"
                                            className="quantity-input mx-2 border-0 rv-label-muted "
                                            id="quantity"
                                            value={quantity}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value;
                                              if (value === "") {
                                                setQuantity("");
                                              } else {
                                                setQuantity(
                                                  Math.max(
                                                    1,
                                                    Number(value)
                                                  )
                                                );
                                              }
                                            }}
                                            min={1}
                                          />
                                          <div className="text-end flex-grow-1">
                                            <button
                                              className="border-0 bg-transparent"
                                              type="button"
                                              onClick={() =>
                                                setQuantity((prev) =>
                                                  Math.max(1, prev - 1)
                                                )
                                              }
                                            >
                                              <span className="rv-label-muted fw-bold">
                                                -
                                              </span>
                                            </button>
                                            <span className="rv-label-muted ">
                                              |
                                            </span>
                                            <button
                                              className="border-0 bg-transparent fw-bold"
                                              type="button"
                                              onClick={() =>
                                                setQuantity(
                                                  (prev) => prev + 1
                                                )
                                              }
                                            >
                                              <span className="rv-label-muted ">
                                                +
                                              </span>
                                            </button>
                                          </div>
                                        </InputGroup>
                                      </FormGroup>
                                    </Col>{" "}
                                  </Row>
                                  <div className="text-center text-black fw-bold fs-18 my-1">
                                    Resource Override
                                  </div>
                                  <Row className="gy-3 mt-1">
                                    <Row>
                                      {(Array.isArray(
                                        overrideResource[adjustedOfferIndex]
                                      )
                                        ? overrideResource[adjustedOfferIndex]
                                        : []
                                      ).map((resource, resourceIndex) => (
                                        <div key={resourceIndex} className="d-flex flex-wrap mb-1 flex-column flex-md-row">
                                          <Col lg={3} sm={12} className="pe-2">
                                            <FormGroup>
                                              <LabelText
                                                htmlFor={"resourceName"}
                                                classLabelName={
                                                  "ms-0 rv-form-label"
                                                }
                                                className={"text-danger"}
                                                displayText={
                                                  "Resource Name"
                                                }
                                              />
                                              <LabelText
                                                htmlFor={"resourceName"}
                                                classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                                                displayText={
                                                  "Enter Resource Name"
                                                }
                                              />

                                              <SelectField
                                                name={`resourceName-${resourceIndex}`}
                                                options={resourceOptions
                                                  .filter(
                                                    (option) =>
                                                      !overrideResource[
                                                        adjustedOfferIndex
                                                      ]?.some(
                                                        (r) =>
                                                          r.resourceName
                                                            ?.value ===
                                                          option
                                                      )
                                                  )
                                                  .map((option) => ({
                                                    value: option,
                                                    label: option,
                                                  }))}
                                                value={
                                                  resource.resourceName
                                                }
                                                handleChange={(
                                                  selectedOption
                                                ) => {
                                                  setOverrideResource(
                                                    (prev) => ({
                                                      ...prev,
                                                      [adjustedOfferIndex]: prev[
                                                        adjustedOfferIndex
                                                      ].map((r, i) =>
                                                        i ===
                                                          resourceIndex
                                                          ? {
                                                            ...r,
                                                            resourceName:
                                                              selectedOption,
                                                          }
                                                          : r
                                                      ),
                                                    })
                                                  );
                                                }}
                                                placeholder=""
                                                isRVStyle={true}
                                                isClearable={true}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col lg={3} sm={12} className="pe-2">
                                            <FormGroup>
                                              <LabelText
                                                htmlFor={"Value"}
                                                classLabelName={
                                                  "ms-0 rv-form-label"
                                                }
                                                className={"text-danger"}
                                                displayText={"Value"}
                                              />
                                              <LabelText
                                                htmlFor={"resourceName"}
                                                classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                                                displayText={
                                                  "Enter Value"
                                                }
                                              />
                                              <InputField
                                                name={`value-${resourceIndex}`}
                                                placeholder={""}
                                                type={"text"}
                                                className={"form-control"}
                                                id={`value-${resourceIndex}`}
                                                value={resource.value}
                                                handleChange={(e) => {
                                                  const newValue =
                                                    e.target.value;
                                                  setOverrideResource(
                                                    (prev) => ({
                                                      ...prev,
                                                      [adjustedOfferIndex]: prev[
                                                        adjustedOfferIndex
                                                      ].map((r, i) =>
                                                        i ===
                                                          resourceIndex
                                                          ? {
                                                            ...r,
                                                            value:
                                                              newValue,
                                                          }
                                                          : r
                                                      ),
                                                    })
                                                  );
                                                }}
                                              />
                                            </FormGroup>
                                          </Col>
                                        </div>
                                      ))}
                                    </Row>
                                  </Row>
                                  <div className="text-center text-black fw-bold fs-18 my-1">
                                    Ceiling/Floor
                                  </div>
                                  <Row className="gy-3 mt-1">
                                    <LimitOverride
                                      values={values}
                                      touched={touched}
                                      errors={errors}
                                      setFieldValue={setFieldValue}
                                    />
                                  </Row>
                                  {attributes && (
                                    <div>
                                      <div className="text-center text-black fw-bold fs-18 my-1">
                                        Attributes
                                      </div>
                                      <div className="border border-1 rounded-1 mt-1 overflow-y-auto-200">
                                        <Table className="table">
                                          <thead>
                                            <tr>
                                              <th>Name</th>
                                              <th>Value</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {offer?.provisioningAttributes.map((attribute, index) => (
                                              <tr key={index} className="border border-0">
                                                <td className="border border-0">{attribute.name}</td>
                                                <td className="border border-0">{attribute.value}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  )}
                                  {(roleName === "telcoAdmin" ||
                                    roleName === "telcoOperationUser" ||
                                    roleName === "telcoBusinessUser") &&
                                    selectedOffers.length > 0 && (
                                      <div class="d-flex justify-content-center gap-2 mt-3">
                                        <div className="d-flex gap-2">
                                          <button
                                            type="button"
                                            className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                            onClick={closeSubscriptionModal}
                                          >
                                            <i class="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                            <span class="px-2 ms-2 me-1 fw-bold">
                                              Cancel
                                            </span>
                                          </button>

                                          <button
                                            type="submit"
                                            class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                          >
                                            <i class="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                            <span class="px-2 ms-2 me-1 fw-bold">
                                              Submit
                                            </span>
                                          </button>
                                        </div>

                                      </div>
                                    )}
                                </div>
                              </Form>
                            );
                          }}
                        </Formik>
                      ))}
                  </ModalBody>
                </Modal>
                <Modal
                  isOpen={
                    openViewMoreModalKey === `${serviceIndex}-${adjustedOfferIndex}`
                  }
                  fade={false}
                  toggle={closeViewMoreModal}
                  centered={true}
                >
                  <ModalHeader toggle={closeViewMoreModal}>
                    {offer?.offerName}
                  </ModalHeader>
                  <ModalBody>
                    <OfferCard
                      offer={offer}
                      index={serviceIndex}
                      offerIndex={adjustedOfferIndex}
                      openViewMoreModal={openViewMoreModal}
                      closeViewMoreModal={closeViewMoreModal}
                      isModal={true}
                      handleSelect={handleSelect}
                    />
                    <div className="py-3 text-center">
                      <Button
                        className="w-100 rv-subscription-btn fs-16 fw-bold"
                        onClick={() => {
                          closeViewMoreModal();
                          handleSelect(offer, adjustedOfferIndex, serviceIndex)
                          openSubscriptionModal(serviceIndex, adjustedOfferIndex);
                        }}
                      >
                        Select
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>
              </Col>
            })}
          </Row>
        </div>
      </CarouselItem>
    ));

    return { slides, chunkCount: offerChunks.length };
  };





  return (
    <div className="offers">
      {loading ? (
        <p></p>
      ) : (
        <div>
          {filteredResults.map(([serviceName, offers], index) => {
            const { slides, chunkCount } = offerSlides(offers, index);
            const indicators = [];
            for (let i = 0; i < chunkCount; i++) {
              indicators.push({ key: 'ind-' + i });
            }
            const currentIndex = activeIndices[serviceName] || 0;
            return (
              <div key={index} className="py-3">
                <div className="d-flex justify-content-center w-100">
                  <Row className="px-2 w-95">
                    <Col
                      md={4}
                      xxl={3}
                      sm={12}>
                      <h2 className="fs-5 text-black fw-bold mb-0">{serviceName}</h2>
                    </Col>
                  </Row>

                </div>


                <Carousel
                  activeIndex={currentIndex}
                  next={() => next(serviceName, chunkCount)}
                  previous={() => previous(serviceName, chunkCount)}
                  className="my-3"
                  interval={false}
                >
                  <CarouselIndicators
                    items={indicators}
                    activeIndex={currentIndex}
                    onClickHandler={(newIdx) => goToIndex(serviceName, newIdx)}
                  />

                  {slides}

                  <CarouselControl
                    direction="prev"
                    directionText="Previous"
                    onClickHandler={() => previous(serviceName, chunkCount)}
                    className={currentIndex === 0 ? "d-none" : ""}
                  />
                  <CarouselControl
                    direction="next"
                    directionText="Next"
                    onClickHandler={() => next(serviceName, chunkCount)}
                    className={currentIndex == chunkCount - 1 ? "d-none" : ""}
                  />
                </Carousel>
              </div>
            );
          })}

        </div>
      )}

    </div>
  );
};
